<template>
  <f7-fab-backdrop></f7-fab-backdrop>
  <f7-fab
    v-show="props && !props.loading && loggedUser && !props.showPreview"
    position="right-top"
    class="custom-fab"
  >
    <i class="fas fa-bars"></i>
    <i class="fas fa-times"></i>
    <f7-fab-buttons
      position="bottom"
      style="font-family: 'Outfit', sans-serif !important"
    >
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndPreview"
        @click="props.showPreview = false"
        label="Editar Contenido"
        ><i class="fas fa-pen"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndNotPreview && !isAdminPage"
        @click="navigateToHome"
        label="Editar Página"
        ><i class="fas fa-rocket"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndNotPreview && isAdminPage"
        @click="props.showPreview = true"
        label="Vista Previa"
        ><i class="fas fa-eye"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndNotPreview"
        href="/admin/links/"
        label="Ordenar Bloques"
        ><i class="fas fa-layer-group"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndNotPreview"
        href="/admin/qr/"
        label="Mi Código QR"
        ><i class="fas fa-qrcode"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndNotPreview"
        @click="copyLinkToClipboard"
        label="Compartir Link"
        ><i class="fas fa-share-alt"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="showStatsButton"
        href="/admin/dash/"
        label="Estadísticas"
        ><i class="fas fa-chart-bar"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndNotPreview"
        href="/admin/account/"
        label="Mi Cuenta"
        ><i class="fas fa-user"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndNotPreview"
        @click="openMainVideoTutorial"
        label="Ayuda"
        class="fab-help-button"
        ><i class="fas fa-question-circle"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="showProUpgradeButton"
        @click="TryOrBuyPro"
        label="Pasate a Pro"
        class="fab-pro-button"
        ><i class="fas fa-crown"></i
      ></f7-fab-button>
      <f7-fab-button
        fab-close
        v-show="isUserLoggedAndNotPreview"
        @click="signOut"
        label="Cerrar Sesión"
        class="fab-signout-button"
        ><i class="fas fa-sign-out-alt"></i
      ></f7-fab-button>
    </f7-fab-buttons>
  </f7-fab>

  <f7-fab
    v-show="!props.loading && loggedUser && props.showPreview"
    position="right-top"
    class="custom-fab"
    @click="props.showPreview = false"
  >
    <i class="fas fa-pen"></i>
  </f7-fab>

  <f7-fab
    v-show="isUserLoggedAndNotPreview && isAdminPage"
    @click="addLink"
    position="right-bottom"
    class="custom-fab blob green"
  >
    <i class="fas fa-plus"></i>
  </f7-fab>

  <f7-fab
    v-show="isUserLoggedAndNotPreview && isAdminPage"
    @click="navigateToCustomizePageSheet"
    position="left-bottom"
    class="custom-fab"
  >
    <i class="fas fa-palette"></i>
  </f7-fab>
</template>

<script>
import { f7, f7ready, useStore } from "framework7-vue";
import { ref } from "vue";
import account from "../../js/account";
import store from "../../js/store";
import utils from "../../js/utils";

export default {
  setup() {
    const loggedUser = ref(localStorage.getItem("token"));
    const suscripcion = useStore("suscripcion");
    const bloquesLocal = useStore("bloquesLocal");
    const local = useStore("local");
    return {
      loggedUser,
      suscripcion,
      bloquesLocal,
      local,
    };
  },
  props: {
    props: Object,
    f7router: Object,
    f7route: Object,
  },
  data() {
    return {
      currentPath: window.location.pathname,
      routeChangeHandler: null,
    };
  },
  mounted() {
    const self = this;
    // Actualizar currentPath inicialmente
    self.updateCurrentPath();
    
    // Usar f7ready para asegurarse de que Framework7 esté listo
    f7ready(() => {
      // Inicializar currentPath con la ruta actual
      if (f7.views && f7.views.main && f7.views.main.router) {
        const router = f7.views.main.router;
        self.currentPath = router.currentRoute?.url || router.currentRoute?.path || window.location.pathname;
        
        // Escuchar cambios de ruta del router de Framework7
        self.routeChangeHandler = (newRoute) => {
          self.currentPath = newRoute.url || newRoute.path || window.location.pathname;
        };
        router.on('routeChange', self.routeChangeHandler);
      }
    });
    
    // También escuchar cambios en window.location (por si acaso)
    window.addEventListener('popstate', () => {
      self.updateCurrentPath();
    });
  },
  beforeUnmount() {
    const self = this;
    // Limpiar listeners
    if (f7 && f7.views && f7.views.main && f7.views.main.router && self.routeChangeHandler) {
      f7.views.main.router.off('routeChange', self.routeChangeHandler);
    }
    window.removeEventListener('popstate', self.updateCurrentPath);
  },
  watch: {
    f7route: {
      handler(newRoute) {
        if (newRoute && newRoute.path) {
          this.currentPath = newRoute.path;
        }
      },
      immediate: true,
    },
  },
  computed: {
    isUserLoggedAndNotPreview() {
      return this.loggedUser && !this.props.showPreview;
    },
    isUserLoggedAndPreview() {
      return this.loggedUser && this.props.showPreview;
    },
    showStatsButton() {
      return this.loggedUser && this.suscripcion.nombre_suscripcion_actual === 'Pro';
    },
    showProUpgradeButton() {
      return this.loggedUser && this.suscripcion.nombre_suscripcion_actual === 'Gratuito';
    },
    canAddMoreBlocks() {
      return this.bloquesLocal.length < 50;
    },
    isAdminPage() {
      // Usar la propiedad reactiva currentPath
      // Normalizar la ruta para comparar (eliminar trailing slash si existe, excepto para /admin/)
      const normalizedPath = this.currentPath.replace(/\/$/, '') || '/';
      return normalizedPath === '/admin';
    }
  },
  methods: {
    updateCurrentPath() {
      const self = this;
      // Intentar obtener la ruta actual del router primero
      let newPath = null;
      if (self.f7router && self.f7router.currentRoute) {
        newPath = self.f7router.currentRoute.url || self.f7router.currentRoute.path;
      } else if (f7.views && f7.views.main && f7.views.main.router && f7.views.main.router.currentRoute) {
        newPath = f7.views.main.router.currentRoute.url || f7.views.main.router.currentRoute.path;
      }
      
      // Si no se encontró en el router, usar window.location.pathname
      if (!newPath) {
        newPath = window.location.pathname;
      }
      
      self.currentPath = newPath;
    },
    navigateToHome() {
      const self = this;
      f7.views.main.router.navigate("/admin/", {
        reloadCurrent: true,
      });
      // Actualizar currentPath después de navegar
      setTimeout(() => {
        self.updateCurrentPath();
      }, 100);
    },
    navigateBack() {
      const self = this;
      f7.views.main.router.navigate("/admin/dash/");
    },
    addLink() {
      if (!this.canAddMoreBlocks) {
        utils.toastConfig.text =
          "Con el Plan Gratuito solo puedes crear hasta 50 Bloques. Pasate a Pro!";
        utils.toastConfig.cssClass = "error-toast";
        f7.toast.create(utils.toastConfig).open();
      } else {
        f7.views.main.router.navigate("/admin/new-link-type/");
      }
    },
    navigateToCustomizePageSheet() {
      const self = this;
      f7.views.main.router.navigate("/admin/customize-page-sheet/");
    },
    openMainVideoTutorial() {
      const self = this;

      f7.panel.close();
      store.dispatch("setOpenOnboardingSheet", true);
    },
    signOut() {
      account.signOut();
    },
    TryOrBuyPro() {
      const self = this;

      if (self.suscripcion.prueba_gratuita === 0) {
        store.dispatch("setOpenTryProSheet", true);
      } else if (self.suscripcion.prueba_gratuita === 1) {
        store.dispatch("setOpenBuyProSheet", true);
      }
    },
    copyLinkToClipboard() {
      const self = this;

      if (f7.device.desktop) {
        navigator.clipboard.writeText(self.local.url_local);
        utils.toastConfig.text = "Link copiado al portapapeles";
        utils.toastConfig.cssClass = "success-toast";
        f7.toast.create(utils.toastConfig).open();
      } else {
        // native Share
        navigator.share({
          title: self.local.nombre_local,
          text: self.local.nombre_local,
          url: self.local.url_local,
        });
      }
    },
  },
};
</script>

<style scoped>
.fab-help-button {
  background-color: #ffffff !important;
  color: #0f8834 !important;
}

.fab-pro-button {
  background: #ffc314 !important;
  color: #222 !important;
}

.fab-signout-button {
  background: #da5151 !important;
  color: white !important;
}
</style>